import * as React from "react";
import { Box } from "@mui/material";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import { Typography } from "@mui/material";
import {
  StyledTabContainer,
  StyledIndividualTabV2,
} from "../../Components/CustomTab";
import { useSelector } from "react-redux";
export default function TabWithColorDigitalTwins(props) {
  const value = useSelector((state) => state.DigitalTwinsTabValue.value);

  const handleChange = (event, newValue) => {
    props.ChangeTheTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <StyledTabContainer
        value={value}
        onChange={handleChange}
        aria-label="styled tabs example"
        elevation={1}
        myColor={ThemeProperties.purple}
      >
        {props.tabs.map((item, index) => (
          <StyledIndividualTabV2
            key={index}
            label={
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography variant="specificTabBold">
                  <Box sx = {{lineHeight: '24px'}}>{item.name}</Box>
                </Typography>
              </div>
            }
          />
        ))}
      </StyledTabContainer>
    </Box>
  );
}
